import React from 'react'

// Section heading used above each Overview section group.
const SectionHeading = ({ title, className }) => {
    return (
        <h2
            className={`text-xl font-bold text-[#21242b] mb-4 ${
                className || ''
            }`}
        >
            {title}
        </h2>
    )
}

export default SectionHeading
